export function buildOssDownloadResponse(fileName: string) {
  const safeFileName = fileName.replace(/["\\]/g, '_');
  return {
    'content-disposition': `attachment; filename="${safeFileName}"; filename*=UTF-8''${encodeURIComponent(fileName)}`,
  };
}
